import { blue, grey, red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: blue[500],
    },
    secondary: {
      main: grey[600],
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    h1: {
      fontSize: '2rem',
      marginBottom: 20,
    },
    h2: {
      fontSize: '1.5rem',
      marginBottom: 10,
    },
    h3: {
      fontSize: '1.2rem',
      marginBottom: 10,
    },
  },
});

export const drawerWidth: number = 240;

export default theme;
